// src/lib/firebase.js  (CRA-friendly)
import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";



// ✅ CRA uses process.env with REACT_APP_ prefix
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FB_API_KEY,
  authDomain: process.env.REACT_APP_FB_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FB_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FB_STORAGE_BUCKET,
  appId: process.env.REACT_APP_FB_APP_ID,
};

// Helpful guard during dev
if (!firebaseConfig.apiKey) {
  throw new Error(
    "Missing Firebase env vars. In CRA, set REACT_APP_FB_* in your .env/.env.local and restart."
  );
}

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);


setPersistence(auth, browserLocalPersistence).catch((e) => {
  console.warn("Auth persistence fell back:", e?.message);
});

export const db = getFirestore(app);
export const storage = getStorage(app);